import React from 'react';
import { Suspense, lazy } from 'react';
import Checkbox from './Checkbox';
import Buttons from './Buttons';
import Currency from './Currency';
import DateField from './DateField';
import Select from './Select';
import Number from './Number';
import Text from './Text';
import Textarea from './Textarea';
import Email from './Email';
import Switch from './Switch';
//import Recaptcha from './Recaptcha';
//const Switch from './Switch';

export default class Input extends React.Component {
  constructor(props) {
    super(props);
  }


  field = () => {
    let propss = {...this.props}
    propss.ph = null;
    /*if(this.props.label === null){
      propss.ph = (!this.props.placeholder) ? this.props.name : this.props.placeholder;
    }else{*/
      propss.ph = this.props.placeholder;
    //}
    propss.className = '';
    switch (this.props.type) {
      default:
        return(
          <Text {...propss} />
        )
      break;

      case "buttons":
        return(
          <Buttons {...propss} />
        )
      break

      case "checkbox":
        return(
          <Checkbox {...propss} />
        )
      break

      case "currency":
        return(
          <Currency {...propss} />
        )
      break

      case "date":
        return(
          <DateField {...propss} />
        )
      break

      case "email":
        return(
          <Email {...propss} />
        )
      break

      case "select":
        return(
          <Select {...propss} />
        )
      break

      case "textarea":
        return(
          <Textarea {...propss} />
        )
      break

      case "number":
        return(
          <Number {...propss} />
        )
      break

      case "switch":
        return(
          <Switch {...propss} />
        )
      break

    }
  }


  render() {
    let className = this.props.className ? " "+this.props.className : '';
    return (
      <div className={"form-group" + className}>
        {this.props.label !== null &&
          <label htmlFor={this.props.name} className="form-label">{this.props.label ? this.props.label : this.props.name}</label>
        }
        {this.props.description !== null &&
          <p className="description">{this.props.description}</p>
        }

        <div className={this.props.mainCntClass}>
          {this.field()}
        </div>

        {this.props.help && <div className="form-text">{this.props.help}</div>}
        {(this.props.required)&&
          <div className="valid-feedback">
            Looks good!
          </div>
        }
      </div>
    )
  }
}
